import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createContext, useContext } from 'react';
import { config } from '../../../components/HotelDetailsOverlay/config.js';
const Context = createContext(config);
export const ConfigProvider = ({
  config,
  children
}) => _jsx(Context.Provider, {
  value: config,
  children: children
});
export const useConfig = () => {
  return useContext(Context);
};